import React from 'react';
import PropTypes from 'prop-types';

const SimpleOfferTabNav = ({ tabs, active, onSelect }) => (
  <div className="simple-offer-tabs" role="tablist">
    {tabs.map((tab) => {
      const isActive = active === tab.key;
      return (
      <button
        key={tab.key}
        id={`simple-offer-tab-${tab.key}`}
        type="button"
        role="tab"
        aria-selected={isActive}
        aria-controls="simple-offer-tabpanel"
        className={`simple-offer-tabs__tab${isActive ? ' simple-offer-tabs__tab--active' : ''}`}
        onClick={() => onSelect(tab.key)}
      >
        {tab.label}
        {typeof tab.count === 'number' && (
          <span className="simple-offer-tabs__badge">{tab.count}</span>
        )}
      </button>
      );
    })}
  </div>
);

SimpleOfferTabNav.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    count: PropTypes.number,
  })).isRequired,
  active: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default SimpleOfferTabNav;
